import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

export interface FollowingUser {
  user_id: string;
  full_name: string | null;
  avatar_url: string | null;
}

export function useUserFollowingForList(userId?: string) {
  const [following, setFollowing] = useState<FollowingUser[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchFollowing = async () => {
    if (!userId) {
      setLoading(false);
      return;
    }

    try {
      setLoading(true);
      
      // Use database function to get following list (bypasses RLS)
      const { data: followingData, error } = await supabase.rpc('get_following_list', {
        _user_id: userId
      });

      if (error) throw error;

      setFollowing(followingData || []);
      setError(null);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Error al cargar siguiendo');
      setFollowing([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchFollowing();
  }, [userId]);

  return {
    following,
    loading,
    error,
    refetch: fetchFollowing
  };
}